module.exports = __webpack_public_path__ + "static/media/14UNEP14.c6e02ad1.jpg";